import { RuleModel } from "./rule.model";

export class OrdersRulesModel {
	isValid: boolean | null;
	deferredRuleIndicator: string;
	violation: RuleModel[];
	analysis: any[];
	scores: OrdersRulesScoresModel;
	executedRuleSets: string[];

	constructor() {
		this.isValid = null;
		this.deferredRuleIndicator = '';
		this.violation = [];
		this.analysis = [];
		this.scores = new OrdersRulesScoresModel();
		this.executedRuleSets = [];
	}
}

export class OrdersRulesScoresModel {
	ruleScoreItem: OrdersRulesScoresRuleScoreModel[];
	total: number;
	overall: any;
}

export class OrdersRulesScoresRuleScoreModel {
	groupName: string;
	weight: number;
	totalRules: number;
	totalRulesSeverity: OrdersRulesScoresRuleScoreSeverityModel;
	ruleViolation: number;
	ruleViolationSeverity: OrdersRulesScoresRuleScoreSeverityModel;
	average: number;
	weightedAverage: number;
	scoreDisplay: string;
	score: number;
	style: OrdersRulesScoresRuleScoreStyleModel;
}

export class OrdersRulesScoresRuleScoreSeverityModel {
	Low: number;
	Moderate: number;
	High: number;
}

export class OrdersRulesScoresRuleScoreStyleModel {
	backgroundColor?: string;
	iconClass?: string;
	[paramName: string]: string;
}
